import barba from '@barba/core'
import { navigation } from './navigation.js'
import { smoothScroll, scrollToStart } from './lenis-scroll.js'
import { animation } from './animation.js'
import { swiper } from './swiper.js'
import { createPulseMark } from './pulse-mark.js'

let logoAnimation

export const header = () => {
	logo()
}

const logo = () => {

	const el = document.querySelector('[data-animation="header-logo"]')

	// the header sits outside the barba container, so this only ever runs once
	if (!el || logoAnimation) return

	// returns null under reduced motion or a missing container, which leaves the
	// static inline svg in place and skips the request entirely
	logoAnimation = createPulseMark(el.querySelector('[data-el="logo-lottie"]'), {
		onReady: () => { el.dataset.logoStatus = 'animated' },
		onFail: () => { logoAnimation = null },
	})

	if (!logoAnimation) return

	pauseWhenHidden()
}

const pauseWhenHidden = () => {

	const html = document.documentElement

	const headerIsVisible = () => html.dataset.scrolled !== 'true' || html.dataset.revealHeader === 'true'

	let paused = false

	const sync = () => {
		if (!logoAnimation) return

		const shouldPause = document.hidden || !headerIsVisible()

		if (shouldPause === paused) return

		paused = shouldPause
		shouldPause ? logoAnimation.pause() : logoAnimation.play()
	}

	new MutationObserver(sync).observe(html, {
		attributes: true,
		attributeFilter: ['data-scrolled', 'data-reveal-header'],
	})

	document.addEventListener('visibilitychange', sync)
}

export default () => { }
